import {
  IGroupInfo,
  INonPatientChats,
  IPatientChats,
} from "@home-health-notify/domain";
import { ILeaveAndDeleteGroupRequest } from "@home-health-notify/models";
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton, Typography } from "@mui/material";
import {
  ApiErrorHandler,
  OrganizationContext,
  useTranslation,
} from "hhn-commons";
import { useSnackbar } from "notistack";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router";
import { ConfirmationDialog } from "../../../common/ConfirmationDialog";
import { RightDrawerContext } from "../../../context/RightDrawerContext";
import { ROUTES } from "../../../routes";
import { SettingsOption } from "./Settings.style";

const LeaveAndDeleteGroup = ({ groupInfo }: { groupInfo: IGroupInfo }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "groupChatInfo" });
  const { selectedOrgUser } = useContext(OrganizationContext);
  const navigate = useNavigate();
  const { closeDrawer } = useContext(RightDrawerContext);

  const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] =
    useState<boolean>(false);

  const closeConfirmationDialog = () => {
    setIsConfirmationDialogOpen(false);
  };
  const openConfirmationDialog = () => {
    setIsConfirmationDialogOpen(true);
  };

  const getRequestPayload = () => {
    const requestPayload: ILeaveAndDeleteGroupRequest = {
      id: groupInfo.id,
      deleteChat: true,
    };
    return requestPayload;
  };

  const leaveAndDeleteGroup = async () => {
    try {
      const chatManager =
        selectedOrgUser?.chatManager.getChatManagerForGroupType(
          groupInfo.groupType,
        ) as IPatientChats | INonPatientChats;
      await chatManager.leaveAndDeleteGroup(getRequestPayload());
      enqueueSnackbar("Group left successfully", { autoHideDuration: 3000 });
      const orgId = selectedOrgUser?.getOrganization().organizationId;
      navigate(`${ROUTES.ORGANIZATIONS}/${orgId}/${ROUTES.CHATS}`);
      closeDrawer();
    } catch (e) {
      ApiErrorHandler(e, enqueueSnackbar);
    } finally {
      closeConfirmationDialog();
    }
  };

  return (
    <SettingsOption>
      <Typography sx={{ color: "red" }}>
        {tNs("leaveAndDeleteGroup")}
      </Typography>
      <IconButton
        onClick={openConfirmationDialog}
        data-testid="leave-delete-group-button"
      >
        <DeleteIcon sx={{ color: "red" }} />
      </IconButton>
      <ConfirmationDialog
        isOpen={isConfirmationDialogOpen}
        onClose={closeConfirmationDialog}
        confirmationTitle="Leave And Delete Group"
        confirmationMessage="Are you sure you want to delete this group?"
        confirmationButtonText="Delete"
        onConfirmationAction={leaveAndDeleteGroup}
        shouldCloseOnConfirm={false}
      />
    </SettingsOption>
  );
};

export default LeaveAndDeleteGroup;
